import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SectionTopHeader = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${globals.MOON_800};
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 4px;
  align-items: center;
`;

export const SectionFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: calc(${globals.spu} * 3);
`;

/**
 * HTML sections are used to group thematically related content.
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/section#usage_notes
 * Sections should ideally contain a heading, although the use of a single header
 * per section is allowed.
 */
export const Section = styled.section<{
  noPadding?: boolean;
  transparentBackground?: boolean;
}>`
  position: relative;
  margin-bottom: 40px;
  background-color: ${p => (p.transparentBackground ? 'none' : globals.WHITE)};
  border-radius: 8px;
`;

export const SectionHeaderText = styled.div`
  font-size: calc(${globals.fontSizeStandard} * 1.5);
`;

export const SectionHeaderSubText = styled.span`
  font-size: calc(${globals.fontSizeStandard} * 0.875);
  color: ${globals.textSecondary};
  margin-left: calc(${globals.spu} * 1);
  position: relative;
  top: 2px;

  display: inline-flex;
  align-items: center;
`;

export const SectionHeaderSubTextIcon = styled.img`
  margin-right: calc(${globals.spu} * 0.5);
`;

export const SectionHeaderActions = styled.div`
  height: 24px;
  display: flex;
  align-items: center;
`;
